import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    document.getElementById("mobile-nav").classList.toggle("-is-open")
  }
}
